// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import ElementUI  from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';


import moment from 'moment'
import {requestUtil} from "./util/requestUtil";

Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(ElementUI);

Vue.use(requestUtil);
Vue.prototype.$moment = moment;

Vue.prototype.baseImageUrl="https://image.shhtys.cn";

Vue.prototype.getUrlKey=function(name){
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}




Vue.prototype.$checkMobile=function (val){
    if(!(/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(val))){
        return false;
    }
    return true;
};

Vue.prototype.$percentgae=function (number) {
  if(isNaN(number)){
      return 0;
  }
  if (number == 0){
      return 0;
  }
  return (Math.round( number* 10000) / 100.00)+"%";// 小数点后两位百分比
}

Vue.prototype.historyBack=function(){
    history.back(-1);
}

Vue.prototype.historyBackPath=function (path){
    this.$router.push("/"+path);
}


Vue.prototype.$addTableRow=function (scope){
    scope.store.table.$options.propsData.data.push(this.$copy(scope.store.table.$attrs.bean));
}

Vue.prototype.$copyTableRow=function (scope){
    scope.store.table.$options.propsData.data.push(this.$copy(scope.row));
}

Vue.prototype.$deleteTableRow=function (scope){
    scope.store.table.$options.propsData.data.splice(scope.$index, 1);
    if(scope.store.table.$options.propsData.data.length<1){
        scope.store.table.$options.propsData.data.push(this.$copy(scope.store.table.$attrs.bean));
    }
}

Vue.prototype.$lastMonth=function () {
  let str=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
  let num=this.$moment(str, "YYYY-MM-DD").daysInMonth();
  let str1=this.$moment(str+"-"+num,"YYYY-MM-DD").format('YYYY-MM-DD');
  str=this.$moment(str+"-01","YYYY-MM-DD").format('YYYY-MM-DD');
  let dayArray=[];
  dayArray.push(str);
  dayArray.push(str1);
  return dayArray;
}


Vue.prototype.$getAuthUrl=function (appid,path){
    const url="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri="+path+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
    return url;
}

Vue.prototype.$mul=function accMul(arg1,arg2)
{
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
};

Vue.prototype.$getInteboQyWechatLogin=function (path){
    let url="https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww86e75093d6334725&redirect_uri="+encodeURIComponent(window.location.href)+"&response_type=code&scope=snsapi_base&state=STATE&agentid=1000002#wechat_redirect"
    let code=this.$getUrlKey('code');
    if(code) {
        this.$getInteboCorpUserId(code,path);
        //return code;
    }
    if(!code){
        window.location.href = url;
    }
}

Vue.prototype.$getHTYSQyWechatLogin=function (path){
    let url="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwb9fb80fecb56fde3&redirect_uri="+encodeURIComponent(window.location.href)+"&response_type=code&scope=snsapi_base&state=STATE&agentid=1000002#wechat_redirect"
    let code=this.$getUrlKey('code');
    if(code) {
        this.$getHTYSCorpUserId(code,path);
        //return code;
    }
    if(!code){
        window.location.href = url;
    }
}

Vue.prototype.$getInteboCorpUserId=function (code,path){
    this.$post("wechatback/getInteboCorpUserId",{code:code}).then(res=>{
        if(res.sucess){
            let token=res.object.token;
            let staff=res.object.staff;
            localStorage.setItem("token", token);
            localStorage.setItem("staffid", staff.staffid);
            localStorage.setItem("storeid", staff.storeid);
            if(staff.deptid) {
                localStorage.setItem("deptid", staff.deptid);
            }
            localStorage.setItem("staffname", staff.staffname);
            localStorage.setItem("posid",staff.posid);
            this.$router.push({path:path});
        }
        else{
            window.WeixinJSBridge.call('closeWindow');
        }
    });
}

Vue.prototype.$getHTYSCorpUserId=function (code,path){
    this.$post("htyswechat/getHTYSCorpUserId",{code:code}).then(res=>{
        if(res.sucess) {
            let token = res.object.token;
            let staff = res.object.staff;
            localStorage.setItem("token", token);
            localStorage.setItem("staffid", staff.staffid);
            localStorage.setItem("storeid", staff.storeid);
            localStorage.setItem("storename", staff.storename);
            if (staff.deptid) {
                localStorage.setItem("deptid", staff.deptid);
            }
            localStorage.setItem("staffname", staff.staffname);
            localStorage.setItem("posid", staff.posid);
            localStorage.setItem("parentstoreid",res.object.parentstoreid);
            this.$router.push({path: path});
        }
        else{
            window.WeixinJSBridge.call('closeWindow');
        }
    });
}

Vue.prototype.$asNumber=function(val) {
    if (val=="" || val==undefined || val==null) {
        return 0;
    }
    else {
        return parseFloat(val);
    }
};

//数字相加
Vue.prototype.$addNumber=function(num1, num2) {
    var sq1, sq2, m;
    num1=this.$asNumber(num1);
    num2=this.$asNumber(num2);
    try {
        sq1 = num1.toString().split(".")[1].length;
    }
    catch (e) {
        sq1 = 0;
    }
    try {
        sq2 = num2.toString().split(".")[1].length;
    }
    catch (e) {
        sq2 = 0;
    }
    m = Math.pow(10, Math.max(sq1, sq2));
    return (this.$mul(num1 , m) + this.$mul(num2 , m)) / m;
};

Vue.prototype.$parseInt=function (val){
  if(val==null){
    return 0;
  }
  if(isNaN(val)){
    return 0;
  }
  return parseInt(val);
}

Vue.prototype.$getBillName=function(billtype) {
  switch (billtype) {
    case 1:return "会员开卡";
    case 2:return "会员充值";
    case 3:return "购买疗程";
    case 4:return "购买套餐";
    case 5:return "会员转卡";
    case 6:return "会员并卡";
    case 7:return "会员补卡";
    case 8:return "会员换卡";
    case 9:return "卡内兑换";
    case 10:return "买年疗";
    case 11:return "退卡";
    case 12:return "收购转卡";
    case 13:return "购买活动券";
    case 14:return "980返还";
    case 88:return "收银";
  }
};


Vue.prototype.$delRepeat = function (array) {
  var temp = {}, len = array.length;
  for (var i = 0; i < len; i++) {
    var tmp = array[i];
    if (!temp.hasOwnProperty(tmp)) {//hasOwnProperty用来判断一个对象是否有你给出名称的属性或对象
      temp[array[i]] = "yes";
    }
  }

  len = 0;
  var tempArr = [];
  for (var i in temp) {
    tempArr[len++] = i;
  }
  return tempArr;
}

Vue.prototype.$copy=function (object) {
  return JSON.parse(JSON.stringify(object));
};

Vue.prototype.$getSb=function (){
  var u = navigator.userAgent;
  if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
    return 'windows';
  } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
    return 'macOS';
  } else if (!!u.match(/iphone/i)){
    return 'iphone';
  } else if(!!u.match(/Ipad/i)){
    return "ipad";
  }
  else if (!!u.match(/android/i)) {
    return 'android';
  } else {
    return 'other';
  }
};


Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function() {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
});


/**
 * 仅在「精细指针」环境（多为键鼠桌面端）动态加载 touch 模拟，减少移动端包体与行为干扰。
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/pointer
 */
function loadTouchEmulatorIfFinePointer() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    try {
        if (window.matchMedia('(pointer: fine)').matches) {
            import('@vant/touch-emulator').catch(() => {})
        }
    } catch (_) {
        /* matchMedia 不可用时跳过 */
    }
}
loadTouchEmulatorIfFinePointer()


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js